import React from 'react';

import { List } from '../../components';
import { ListContainer } from '../../containers';
import { useRefreshPage } from '../../hooks/useRefreshPage';

import StocktakeListItem from './StocktakeListItem';

const StocktakeList = ({
	items,
	refetch,
	customProps,
}) => {
	const [refreshPage, isRefreshing] = useRefreshPage(refetch);

	return (
		<List
			items={items}
			listItemComponent={StocktakeListItem}
			onRefresh={refreshPage}
			isRefreshing={isRefreshing}
			emptyListMessage="No stocktakes found"
			autoScrollTop={true}
			showControls={true}
			removeTopMargin={true}
			customProps={customProps}
			assembler={[]}
		/>
	);
};

export default ListContainer(StocktakeList);
